import HeroSection from "./HeroSection";
import MissionPage from "./MissionPage";

const Layout = () => {
  return (
    <div>
      <HeroSection />
      <div className="mt-24 mb-24">
        <MissionPage />
      </div>
    </div>
  );
};

export default Layout;
